/**
 * Makine ödeme işlem logu (DeviceOperationInfoLog "Ödeme İşlemi") → tablo /
 * detay satırı. Makine Kayıtları sayfası ve Satış/İade detayındaki "Makine
 * Kaydı" bölümü (#243) aynı dönüşümü kullanır.
 */

// Ödeme yöntemi etiketleri (satış: metadata.type türetilir, iade: refund.paymentMethod)
export const METHOD_LABEL = {
  app_qr: "BayinerPay QR",
  app_personal_card: "BayinerPay NFC",
  credit_card: "Kredi Kartı",
};

// #253: makine QR satışını artık bayinerpay_qr_purchase yazar; eski kayıtlar
// app_qr_purchase olarak kalır.
const SALE_TYPE_TO_METHOD = {
  bayinerpay_qr_purchase: "app_qr",
  app_qr_purchase: "app_qr",
  bayinerpay_nfc_purchase: "app_personal_card",
  nearpay_purchase: "credit_card",
};

function deriveMethod(op) {
  const m = op?.metadata || {};
  if (m.refund?.paymentMethod) return m.refund.paymentMethod;
  return SALE_TYPE_TO_METHOD[m.type] || null;
}

function deriveAmountKurus(op) {
  const m = op?.metadata || {};
  if (m.refund) return Number(m.refund.price) || 0;
  return Number(m.amount) || 0;
}

/** Operasyon logunu tablo/drawer için normalize eder. */
export function toMachineRecordRow(op) {
  const m = op?.metadata || {};
  const method = deriveMethod(op);
  return {
    _id: op._id,
    op,
    txType: m.refund ? "refund" : "payment",
    date: op.createdInfo,
    serialNo: op.serialNo,
    deviceName: op.deviceName,
    method,
    methodLabel: METHOD_LABEL[method] || "-",
    amountTL: deriveAmountKurus(op) / 100,
    reference: m.customerReferenceNumber || "",
    intentId: m.intentId || "",
    items: Array.isArray(m.items) ? m.items : [],
    refund: m.refund || null,
    steps: Array.isArray(op.operationSteps) ? op.operationSteps : [],
    description: op.description || "",
  };
}

/**
 * Satış/İade faturasına karşılık gelen makine kayıtları: Intent ID birebir,
 * yoksa Fatura No birebir (sunucu araması "içerir" olduğu için süzülür).
 */
export function matchMachineRecords(rows, { intentId, reference }) {
  if (intentId) {
    const byIntent = rows.filter((r) => r.intentId === intentId);
    if (byIntent.length) return byIntent;
  }
  if (reference) return rows.filter((r) => r.reference === reference);
  return [];
}
